<template>
    <div
        :class="{
            'shop-listing-holder': !classCompare,
            'shop-listing-holder shop-listing-holder--has-compare': classCompare
        }"
    >
        <div
            :class="{
                'product-listing': !classCompare,
                'product-listing product-listing--has-compare': classCompare
            }"
        >
            <div class="container product-listing__container-wrapp">
                <template v-if="!preloader && preloaderTimer">
                    <nav
                        class="product-listing__breadcrumbs"
                        v-show="!preloader"
                    >
                        <a
                            v-for="(brad, index) in bradcrumb"
                            :key="index"
                            :href="brad.link"
                            v-html="brad.name + ' / '"
                        ></a>
                    </nav>

                    <h2 class="section-title product-listing__title">
                        Shop Products
                    </h2>
                    <div class="product-filters-btn-holder">
                        <a
                            href="javascript:;"
                            @click="showFilters = !showFilters"
                            class="btn product-filters-btn"
                            >Show Filters</a
                        >
                    </div>
                </template>
                <Category
                    :categories="categories"
                    v-on:changeCategory="changeCategory"
                    :showFilters="showFilters"
                />
                <Preloader v-if="preloader" />
                <div
                    class="product-listing__wrapper"
                    :class="{
                        'product-listing__wrapper--show': preloaderTimer,
                        '': ''
                    }"
                    v-show="!preloader"
                >
                    <Attributes
                        :filterTerms="filterTerms"
                        :products="products"
                        :kadraGlobal="kadraGlobal"
                        :favorites="favorites"
                        :productWishlist="productWishlist"
                        :wishlist="wishlist"
                        :addToCartLoading="addToCartLoading"
                        :cart="cart"
                        :curentCount="curentCount"
                        v-on:resetFilters="resetFilters"
                        v-on:compareView="compareView"
                    />
                </div>
            </div>
        </div>
        <div class="product-listing__alert" v-if="kadraGlobal.userId === '0'">
            <p class="product-listing__alert-text">
                Some products are only viewable to registered users. To browse
                our full line, please
                <a class="product-listing__alert-link" @click="openLoginPopup()"
                    >log in</a
                >.
            </p>
            <span
                class="product-listing__alert-close js-product-listing__alert-close"
            ></span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Attributes from './Parts/Attribute.vue';
import Category from './Parts/Categories.vue';
import Preloader from './Parts/Preloader.vue';
import Select from './../../../../../src/js/site/select2.js';

export default {
    async mounted() {
        const {
            brand,
            color,
            material,
            sort,
            page,
            limit
        } = Object.fromEntries(new URLSearchParams(window.location.search));
        const windowUrl = window.location.pathname.split('/');
        const category = windowUrl[windowUrl.length - 2];
        await this.$store.dispatch(
            'setAttrShow',
            window?.fwsProducts?.attrShow ?? []
        );
        await this.$store.dispatch(
            'setLimit',
            isNaN(limit) ? window?.fwsProducts?.perPage : parseInt(limit)
        );
        await this.$store.dispatch(
            'setAttributes',
            window?.fwsProducts?.attribute ?? []
        );
        this.setCheckedAttributes(brand, color, material);
        await this.$store.dispatch(
            'setCategories',
            window?.fwsProducts?.category ?? []
        );
        await this.$store.dispatch(
            'setFilteredAttributes',
            window?.fwsProducts?.usedAttrs
        );
        if (
            this.categories.find(x => x.slug === category) ||
            this.categories.forEach(async item => {
                if (item.child) {
                    const child = item.child.find(
                        childItem => childItem.slug === category
                    );
                    if (child) {
                        await this.$store.dispatch('setFilters', {
                            pa_brand: brand ?? '',
                            pa_color: color ?? '',
                            pa_material: material ?? '',
                            sort: sort ?? 'featured',
                            cat: category,
                            shouldFetch: false,
                            page: isNaN(page) ? 1 : parseInt(page),
                            limit: isNaN(limit) ? this.limit : parseInt(limit)
                        });
                    }
                }
            })
        ) {
            await this.$store.dispatch('setFilters', {
                pa_brand: brand ?? '',
                pa_color: color ?? '',
                pa_material: material ?? '',
                sort: sort ?? 'featured',
                cat: category,
                shouldFetch: false,
                page: isNaN(page) ? 1 : parseInt(page),
                limit: isNaN(limit) ? this.limit : parseInt(limit)
            });
        }
        if (category === 'shop') {
            await this.$store.dispatch('setFilters', {
                pa_brand: brand ?? '',
                pa_color: color ?? '',
                pa_material: material ?? '',
                sort: sort ?? 'featured',
                cat: '',
                shouldFetch: false,
                page: isNaN(page) ? 1 : parseInt(page),
                limit: isNaN(limit) ? this.limit : parseInt(limit)
            });
        }
        await this.$store.dispatch('setIsInitialFetch', false);
    },
    components: {
        Attributes,
        Category,
        Preloader
    },
    computed: {
        ...mapState({
            products: state => state.Listing.products,
            attributes: state => state.Listing.attributes,
            categories: state => state.Listing.categories,
            attrShow: state => state.Listing.attrShow,
            user: state => state.Listing.user,
            addToCartLoading: state => state.Cart.addToCartLoading,
            cart: state => state.Cart.cart,
            list: state => state.List.list,
            wishlist: state => state.List.wishlist,
            page: state => state.Pagination.page,
            filters: state => state.Pagination.filters,
            sort: state => state.Pagination.sort,
            selectedAttributes: state => state.Pagination.selectedAttributes,
            fetchInProgress: state => state.Pagination.fetchInProgress,
            limit: state => state.Pagination.limit
        })
    },
    data() {
        return {
            kadraGlobal: kadraGlobal, // global
            allTerms: {}, // all terms in one object by proporty id
            filterTerms: {},
            favorites: {},
            productWishlist: {},
            preloader: true,
            preloaderTimer: false,
            showFilters: false,
            curentCount: 1,
            bradcrumb: [
                {
                    link: kadraGlobal.Url,
                    name: 'Home'
                },
                {
                    link: kadraGlobal.Url + '/shop',
                    name: 'Products'
                }
            ],
            compareCount: 0,
            classCompare: true
        };
    },
    watch: {
        filterTermsChanged() {},
        async attributes() {
            await this.$store.dispatch('getAllCart');
            Select.filtersSelect();
            this.setTerms();
        },
        async categories() {
            await this.$store.dispatch('getList');
            this.setTerms();
            this.removePreloader();
        },
        page() {
            this.initUrl();
        },
        async filters() {
            // await this.$store.dispatch('setProducts', []);
            const {
                cat,
                pa_brand,
                pa_color,
                pa_material,
                sort,
                shouldFetch,
                page
            } = this.filters;
            if (shouldFetch || page !== 1) {
                await this.$store.dispatch('setFetchInProgress', true);
                await this.$store.dispatch('setIsInitialFetch', true);
                this.scrollToTop();
                await this.$store.dispatch('resetProducts');
                await this.$store.dispatch('fetchProducts', {
                    page: page ?? 1,
                    cat: cat ?? '',
                    limit: this.limit,
                    attrs: {
                        pa_brand: pa_brand ?? '',
                        pa_color: pa_color ?? '',
                        pa_material: pa_material ?? ''
                    },
                    sort: sort ?? 'featured',
                    type: 'initial'
                });
                await this.$store.dispatch('setFetchInProgress', false);
                await this.$store.dispatch('setIsInitialFetch', false);
            } else {
                await this.$store.dispatch('setProducts', {
                    products: window?.fwsProducts?.products,
                    page: 1,
                    lastPage: Math.ceil(
                        parseInt(window?.fwsProducts?.ids.length) /
                            parseInt(window?.fwsProducts?.perPage)
                    )
                });
                await this.$store.dispatch('setIds', window?.fwsProducts?.ids);
            }
            this.setUrl();
        },
        list() {
            this.setFavorites();
        },
        wishlist() {
            this.setProductWishlist();
            const ele = document.getElementById('countList');
            if (ele !== null) {
                if (this.wishlist.length !== 0) {
                    ele.style.display = 'flex';
                    ele.innerHTML = this.wishlist.length;
                }
            }
        },
        user() {
            kadraGlobal.userId = this.user;
        }
    },
    methods: {
        async setCheckedAttributes(brand, color, material) {
            const brands = this.attributes.pa_brand;
            const colors = this.attributes.pa_color;
            const materials = this.attributes.pa_material;
            const checkedAttributes = {};
            if (brand) {
                const foundBrand = brands.find(
                    x => x.term_id === parseInt(brand)
                );
                if (foundBrand) {
                    checkedAttributes[foundBrand.taxonomy] = foundBrand.term_id;
                }
            }
            if (color) {
                const foundColor = colors.find(
                    x => x.term_id === parseInt(color)
                );
                if (foundColor) {
                    checkedAttributes[foundColor.taxonomy] = foundColor.term_id;
                }
            }
            if (material) {
                const foundMaterial = materials.find(
                    x => x.term_id === parseInt(material)
                );
                if (foundMaterial) {
                    checkedAttributes[foundMaterial.taxonomy] =
                        foundMaterial.term_id;
                }
            }
            await this.$store.dispatch(
                'setSelectedAttributes',
                checkedAttributes
            );
        },
        openLoginPopup(ele) {
            const popup = document.getElementsByClassName(
                'js-popup-login-form'
            );
            popup[0].classList.add('active');
            popup[0].setAttribute('data-id', ele);
        },
        compareView(flag) {
            this.classCompare = flag;
        },
        async resetFilters() {
            await this.$store.dispatch('setSelectedAttributes', {});
        },
        setFavorites() {
            const obj = {};
            this.list.forEach(item => {
                if (item.status === 'favorites') {
                    obj[item.product_id] = item;
                }
            });
            this.favorites = obj;
        },
        setProductWishlist() {
            const obj = {};
            if (this.wishlist.length !== 0) {
                this.wishlist.forEach(wish => {
                    obj[wish.ID] = [];
                    this.list.forEach(item => {
                        if (item.status === wish.ID) {
                            obj[wish.ID].push(item.product_id);
                        }
                    });
                });
                this.productWishlist = obj;
            }
        },
        setTerms() {
            const data = this.attributes;
            const filterTerms = {};
            const obj = {};
            for (const key in data) {
                if ({}.hasOwnProperty.call(data, key)) {
                    const arr = data[key];
                    arr.forEach(term => {
                        //term.hidden = false;
                        filterTerms[term.term_id] = true;
                        obj[term.term_id] = term;
                    });
                }
            }
            if (this.categories?.length) {
                this.categories?.forEach(term => {
                    obj[term.term_id] = term;
                    if (term.child) {
                        if (!Array.isArray(term.child)) {
                            const newArr = [];
                            for (const key in term.child) {
                                if ({}.hasOwnProperty.call(term.child, key)) {
                                    newArr.push(term.child[key]);
                                }
                            }
                            newArr.forEach(term => {
                                obj[term.term_id] = term;
                            });
                        } else {
                            term.child.forEach(term => {
                                obj[term.term_id] = term;
                            });
                        }
                    }
                });
            }

            this.filterTerms = filterTerms;
        },
        /*****************************
         *  Set url on init
         ******************************/
        initUrl() {
            this.setUrl();
        },
        /*****************************
         *  Set url when add categories and attributes
         ******************************/
        setUrl() {
            const strCat = this.getCategoriesUrl();
            const str = this.setAttrUrl(strCat);
            const orderStr = this.setOrderUrl(str);
            const limitStr = this.setLimitUrl(orderStr);
            const pageStr = this.setPageUrl(limitStr);
            if (pageStr === '') {
                const newUrl = window.location.href.substring(
                    0,
                    window.location.href.indexOf('?')
                );
                window.history.pushState({}, '', newUrl);
            } else {
                window.history.pushState({}, '', pageStr);
            }
        },
        setLimitUrl(str) {
            /*if (str.includes('?')) {
                str += `&limit=${this.limit ?? 100}`;
            } else {
                str += `?limit=${this.limit ?? 100}`;
            }*/
            return str;
        },
        setPageUrl(str) {
            if (str.includes('?')) {
                str += `&page=${this.page ?? 1}`;
            } else {
                str += `?page=${this.page ?? 1}`;
            }
            return str;
        },
        setOrderUrl(str) {
            if (str.includes('?')) {
                str += `&sort=${
                    this.filters.sort ? this.filters.sort : 'featured'
                }`;
            } else {
                str += `?sort=${
                    this.filters.sort ? this.filters.sort : 'featured'
                }`;
            }
            return str;
        },
        setAttrUrl(str) {
            let index = 0;
            for (const key in this.selectedAttributes) {
                if ({}.hasOwnProperty.call(this.selectedAttributes, key)) {
                    const newKey = key.slice(3);
                    index === 0
                        ? (str += `?${newKey}=${this.selectedAttributes[key]}`)
                        : (str += `&${newKey}=${this.selectedAttributes[key]}`);

                    index++;
                }
            }
            return str;
        },
        getCategoriesUrl() {
            if (this.filters.cat === '') {
                return '';
            }

            let category = this.categories.find(
                x => x.slug === this.filters.cat
            );

            if (!category) {
                let parent = null;

                for (const item of this.categories) {
                    if (item.child) {
                        const child = item.child.find(
                            childItem => childItem.slug === this.filters.cat
                        );
                        if (child) {
                            category = child;
                            if (category.parent !== 0) {
                                parent = item;
                            }
                            break;
                        }
                    }
                }

                const url = '/product-category/';
                if (parent) {
                    this.setBreadcrumbs(
                        category.slug,
                        category.name,
                        parent.slug,
                        parent.name
                    );
                    return `${url}${parent.slug}/${category.slug}`;
                } else {
                    this.setBreadcrumbs(category.slug, category.name, '', '');
                    return `${url}${category.slug}`;
                }
            } else {
                this.setBreadcrumbs(category.slug, category.name, '', '');
                return `/product-category/${category.slug}`;
            }
        },
        setBreadcrumbs(last, lastName, parent, parentName) {
            const home = kadraGlobal.Url;
            const arr = [
                {
                    link: home,
                    name: 'Home'
                }
            ];
            if (parent !== '') {
                const obj = {
                    link: home + '/product-category/' + parent,
                    name: parentName
                };
                arr.push(obj);
                const obj1 = {
                    link: home + '/product-category/' + parent + '/' + last,
                    name: lastName
                };
                arr.push(obj1);
            } else {
                const obj1 = {
                    link: home + '/shop',
                    name: 'Products'
                };
                arr.push(obj1);
                const obj = {
                    link: home + '/product-category/' + last,
                    name: lastName
                };
                arr.push(obj);
            }
            this.bradcrumb = arr;
        },
        /*****************************
         *  set array of categories
         ******************************/
        async changeCategory(term) {
            // this.checkedCategories = arr;
            this.setCheckedAttributes('', '', '');
            await this.$store.dispatch('setFilters', {
                ...this.filters,
                cat: term.slug,
                pa_brand: '',
                pa_color: '',
                pa_material: '',
                shouldFetch: true
            });
            this.curentCount = 1;
            this.scrollToTop();
        },
        /*****************************
         *  Scroll top on change category
         ******************************/
        scrollToTop() {
            window.scroll({
                top: 0,
                left: 0
            });
        },
        removePreloader() {
            setTimeout(() => {
                this.preloader = false;
                this.timerPreload();
            }, 0);
        },

        timerPreload() {
            setTimeout(() => {
                this.preloaderTimer = true;
            }, 500);
        }
    }
};
</script>

<style lang="scss" scoped>
.product-listing__wrapper {
    opacity: 0;
    transition: $dur $ease;

    &--show {
        opacity: 1;
    }
}

.product-filters-btn-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    display: none;

    @include mq(1024px) {
        display: inline-block;
    }
}

.product-listing {
    /* min-height: calc(100vh - 650px); */
}

.product-listing__alert {
    background-color: #fff8d7;
    min-height: 60px;
    max-width: 1010px;
    width: 100%;
    border-radius: 6px;
    display: none;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 60px;
    z-index: 10;
    padding: 10px 45px;
    text-align: center;

    @include mq($xl) {
        max-width: 80%;
    }

    @include mq($lg) {
        max-width: 410px;
        margin: 0 auto;
    }

    @include mq($smx) {
        max-width: 290px;
        padding: 10px 35px;
    }
}

.product-listing__alert--active {
    display: flex;
    z-index: 10000;
}

.product-listing__alert--fixed {
    position: absolute;
}

.product-listing__alert-text {
    color: $black;
    font-size: 16px;
    font-family: $font-main;
    letter-spacing: 0.2px;
    font-weight: 500;

    // sass-lint:disable no-vendor-prefixes
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-width: 80%;
        width: 100%;
        display: inline-block;
    }

    @include mq($lg) {
        font-size: 15px;
    }

    @include mq($smx) {
        font-size: 14px;
    }
}

.product-listing__alert-link {
    color: $yellow;
    font-weight: 500;
    position: relative;
    display: inline-block;
    transition: $dur $ease;
    cursor: pointer;

    &:hover {
        color: $theme-green;
        transition: $dur $ease;

        &::after {
            background-color: $theme-green;
            transition: $dur $ease;
        }
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        background-color: $yellow;
        transition: $dur $ease;
    }
}

.product-listing__alert-close {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 15px;
    transition: $dur $ease;
    cursor: pointer;

    @include mq($lg) {
        top: 10px;
        right: 10px;
        transform: translateY(0);
    }

    &:hover {
        transition: $dur $ease;

        &::before,
        &::after {
            background-color: rgba($black, 0.5);
        }
    }

    &::before,
    &::after {
        content: '';
        width: 10px;
        height: 2px;
        background-color: $black;
        position: absolute;
        transition: $dur $ease;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &::before {
        transform: translate(-50%, -50%) rotateZ(45deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotateZ(-45deg);
    }
}

.product-listing__breadcrumbs {
    a {
        &:last-of-type {
            pointer-events: none;
        }
    }
}
</style>
